module.exports = __webpack_public_path__ + "static/img/ssdd.6ef9b40b.png";